(function($) {
	OH.carouselLinkage = function (mediaquery, selectors, target, colorProp) {
		var css = OH.dynamicCSS.register('carousel-linkage', true);
		var changeColor = function (e) {
			var color = document.querySelector(target).getAttribute(colorProp);
			var addCSS = function (item) { css.addRule(item.selector + (item.change ? color : '') + '; }'); };
			var removeCSS = function (n) {
				var idx = 0;
				while (idx < n) {
					css.sheet.deleteRule(0);
					idx += 1;
				}
			};
			removeCSS(css.sheet.cssRules.length);
			selectors.forEach(addCSS);
		};
		if (css != null) {
			css.sheet.media = mediaquery;
			$('.mainVisual__pc').on('translated.owl.carousel initialized.owl.carousel', changeColor);
		}
	};
})(jQuery);